import React from 'react';
import c from './VerticalDivider.module.scss';

export const VerticalDivider = () => {
  return <div className={c.verticalDivider} />;
};

export default VerticalDivider;
